
import {
    Table,
    Header,
    HeaderRow,
    Body,
    Row,
    HeaderCell,
    Cell,
  } from '@table-library/react-table-library/table';
  import { CellTree } from '@table-library/react-table-library/tree';
  import { useTheme } from '@table-library/react-table-library/theme';
  import {
    DEFAULT_OPTIONS,
    getTheme,
  } from '@table-library/react-table-library/material-ui';
  import { useTree } from '@table-library/react-table-library/tree';
  import { KeyboardArrowRight, KeyboardArrowDown } from '@mui/icons-material';
  import OfflinePin from '@mui/icons-material/OfflinePin';
  import { IconButton, Stack, Typography } from '@mui/material';
  import {getKlasifikasiArsip} from 'redux/actions/KlasifikasiArsip';
  import { useDispatch, useSelector } from 'react-redux';
  import { useEffect, useState,useRef } from 'react';
  import PropTypes from 'prop-types';
  import Tooltip from '@mui/material/Tooltip';
  import { makeStyles } from '@mui/styles';
  import InfoDialog from '../InfoDialog';
  import useModal from 'shared/hooks/useModal';
  
  const useStyles = makeStyles((theme) => {
    console.log('theme', theme);
    return {
      customHoverFocus: {
        '&:hover, &.Mui-focusVisible': { backgroundColor: '#00ab4ea3' },
      }
    };
  });
  
  const AddressbookKlasifikasi = ({
    setPayloadOnHide,
    searchText,
    useCRSFE,
    multiselect,
    setPilihan,
  }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const tmpData = useSelector(({ klasifikasiArsip }) => {
      return klasifikasiArsip.detail;
    });
    const [selectedRow, setSelected] = useState(undefined);
    useEffect(() => {
      dispatch(getKlasifikasiArsip(searchText,useCRSFE));
    }, [searchText]);
  
    const data = { nodes: tmpData[0] === null ? [] : tmpData };
  
    let MaterialTheme = getTheme(DEFAULT_OPTIONS);
    // let baseCell = MaterialTheme.BaseCell.replace(
    //   'padding: 16px 16px;',
    //   'padding: 2px 2px;',
    // );
    // MaterialTheme['BaseCell'] = baseCell;
    MaterialTheme['Row'] += `
          &.treeRow {
              background-color: #F4F7FE;
          },
          &.columnWidth {
              min-width: 100px;
              max-width: fit-content;
          },
          &.selected {
              background-color: #E6F6EA;
          }
      `;
    MaterialTheme['HeaderRow'] += `
          .th {
            border-bottom: 1px solid #a0a8ae;
            border-right: 1px solid #a0a8ae;
          }
      `;

    MaterialTheme['CellTree'] += `
      .td {
        padding:0 !important;
      }
    `;
    const theme = useTheme(MaterialTheme);
    const tree = useTree(
      data,
      {
        onChange: onTreeChange,
        state: {
          ids: tmpData[0] === null ? [] : [tmpData ? (tmpData.length > 0 ? tmpData[0].id : null) : null],
        },
      },
      {
        treeIcon: {
          margin: '4px',
          iconDefault: null,
          iconRight: <KeyboardArrowRight />,
          iconDown: <KeyboardArrowDown />,
        },
        indentation: 30,
      },
    );
  
    function onTreeChange(action, state) {
    }
  
    const handleClick = (node) => {
      if (!node.header) {
        if (!multiselect){
          let tmp = {
            id: node.id,
            text: node.topic,
            code: node.code,
            oriItem: node,
          };
          setPilihan([tmp]);
        }
        setSelected(node);
        // setPersonal(node);
      }
    };
  
    const handleDoubleClick = (node) => {
      if (!node.header) {
        let tmp = {
          id: node.id,
          text: node.topic,
          code: node.code,
          oriItem: node,
        };
        if (multiselect) {
          let exist = pilihan.findIndex((item) => {
            return item.code === tmp.code;
          });
          if (exist > -1) {
            setInfo(tmp.text + ' sudah dipilih');
            toggleShowInfo(true);
          } else setPilihan((pilihan) => [...pilihan, tmp]);
        } else {
          setPilihan([tmp]);
          setPayloadOnHide([tmp]);
        }
        setSelected(undefined);
      }
    };

    const timer = useRef();
    const onClickHandler = (node,event) => {
        if (!node.header){
          clearTimeout(timer.current);
          if (event.detail === 1 && node.id !== selected_id) {
              timer.current = setTimeout(handleClick(node), 100)
          } else if (event.detail === 2) {
              handleDoubleClick(node);
          }
        }
    };
  
    const {
      stateAddress: stateInfo,
      toggleShow: toggleShowInfo,
      toggleHide: toggleHideInfo,
    } = useModal();
    const [infoMsg, setInfo] = useState('');
  
    let selected_id = selectedRow ? selectedRow.id : undefined;
    // return (
    //     <></>
    // )
    return (
      <>
        {
          tmpData.length === 0 || tmpData === '' || tmpData[0] == null ? (
            <Stack height={'300px'} justifyContent={'center'} alignItems={'center'}>
              <Typography>Tidak ada data</Typography>
            </Stack>
          ) : (
            <Table className='tableaddressbook' size='small' data={data} tree={tree} theme={theme}>
              {(tableList) => (
                <>
                  <Header>
                    <HeaderRow>
                      <HeaderCell resize>Topik</HeaderCell>
                    </HeaderRow>
                  </Header>
  
                  <Body>
                    {tableList.map((item) => {
                      return (
                        <Row
                          className={
                            selected_id === item.id
                              ? 'selected'
                              : !item.header
                                ? ''
                                : 'treeRow'
                          }
                          key={item.id}
                          item={item}
                          onClick={(node,event)=>onClickHandler(node,event)}
                        >
                          <CellTree item={item}>
                            <div style={{ display: 'flex' }}>
                              {selectedRow
                                ? selectedRow.id === item.id && (
                                  <div
                                    style={{
                                      padding: '5pt 5pt 5pt 0',
                                      display: 'flex',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <Tooltip title='Select Profile'>
                                      <IconButton
                                        aria-label='select'
                                        onClick={() => handleDoubleClick(item)}
                                        className={classes.customHoverFocus}
                                        sx={{
                                          padding: 0,
                                          position: 'initial',
                                          right: 8,
                                          top: 8,
                                          color: 'black',
                                          fontSize: '20pt',
                                        }}
                                      >
                                        <OfflinePin
                                          style={{
                                            fontSize: '20pt',
                                          }}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  </div>
                                )
                                : ''}
  
                              <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <div
                                  style={{
                                    textAlign: 'left',
                                    fontWeight: '700',
                                    fontSize: '10pt',
                                  }}
                                >
                                  {item.topic}
                                </div>
                                <div style={{ textAlign: 'left', fontSize: '10pt' }}>
                                  {!item.header && item.description}
                                </div>
                              </div>
                            </div>
                          </CellTree>
                        </Row>
                      );
                    })}
                  </Body>
                </>
              )}
            </Table>
          )
        }
        <InfoDialog
          stateAddress={stateInfo}
          toggleHide={toggleHideInfo}
          msg={infoMsg}
        />
      </>
    );
  };
  
  export default AddressbookKlasifikasi;
  
  AddressbookKlasifikasi.propTypes = {
    setPayloadOnHide: PropTypes.func,
    setPilihan: PropTypes.func,
    searchText: PropTypes.any,
    useCRSFE:PropTypes.any,
    multiselect:PropTypes.any
  };
  